/**
 * Step 1: Objetivos e Metas Estratégicas
 */
import type { StepProps } from "./types.js";

const OBJECTIVES: [string, string, string][] = [
  ["preservacao", "🛡 Preservação", "Manter poder de compra e proteger o capital contra inflação."],
  [
    "rendaRecorrente",
    "💰 Renda Recorrente",
    "Geração de fluxo de caixa mensal/anual (dividendos, juros).",
  ],
  ["crescimento", "📈 Crescimento", "Acúmulo de capital com maior exposição a riscos de mercado."],
  ["sucessao", "👨‍👩‍👧 Sucessão", "Organização para transmissão de bens com menor custo fiscal."],
  ["hedge", "🌐 Proteção (Hedge)", "Diversificação em moeda forte e jurisdições internacionais."],
];

export function Step1Objetivos({ form, onChange, T }: StepProps) {
  const set = (key: string, value: unknown) => onChange(key, value);

  const togObj = (k: string) => {
    const newObjetivos = form.objetivos.includes(k)
      ? form.objetivos.filter((x) => x !== k)
      : [...form.objetivos, k];
    set("objetivos", newObjetivos);
  };

  return (
    <>
      <h3 style={{ fontSize: 15, fontWeight: 700, color: T.text, margin: "0 0 6px" }}>
        2. Objetivos e Metas Estratégicas
      </h3>
      <p style={{ fontSize: 12, color: T.sub, margin: "0 0 16px" }}>
        Quais são os pilares prioritários para a gestão do patrimônio?
      </p>
      <div style={{ marginBottom: 18 }}>
        <label
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: T.sub,
            textTransform: "uppercase",
            display: "block",
            marginBottom: 8,
            letterSpacing: 0.7,
          }}
        >
          Objetivos de Investimento (múltipla escolha)
        </label>
        {OBJECTIVES.map(([k, lbl, desc]) => (
          <label
            key={k}
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 10,
              padding: "10px 12px",
              borderRadius: 9,
              marginBottom: 6,
              cursor: "pointer",
              background: form.objetivos.includes(k) ? `${T.accent}12` : T.bg,
              border: `1px solid ${form.objetivos.includes(k) ? T.accent : T.border}`,
            }}
          >
            <input
              type="checkbox"
              checked={form.objetivos.includes(k)}
              onChange={() => togObj(k)}
              style={{ marginTop: 2, width: 16, height: 16 }}
            />
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: T.text }}>{lbl}</div>
              <div style={{ fontSize: 11, color: T.sub }}>{desc}</div>
            </div>
          </label>
        ))}
      </div>
      <div style={{ marginBottom: 14 }}>
        <label
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: T.sub,
            textTransform: "uppercase",
            display: "block",
            marginBottom: 4,
          }}
        >
          Meta Curto Prazo (até 12 meses)
        </label>
        <textarea
          value={form.metaCurto || ""}
          onChange={(e) => set("metaCurto", e.target.value)}
          rows={2}
          style={{
            width: "100%",
            padding: "9px 12px",
            borderRadius: 8,
            border: `1px solid ${T.border}`,
            background: T.bg,
            color: T.text,
            fontSize: 13,
            resize: "vertical",
            boxSizing: "border-box",
          }}
        />
      </div>
      <div>
        <label
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: T.sub,
            textTransform: "uppercase",
            display: "block",
            marginBottom: 4,
          }}
        >
          Meta Longo Prazo (5 a 10 anos)
        </label>
        <textarea
          value={form.metaLongo || ""}
          onChange={(e) => set("metaLongo", e.target.value)}
          rows={2}
          style={{
            width: "100%",
            padding: "9px 12px",
            borderRadius: 8,
            border: `1px solid ${T.border}`,
            background: T.bg,
            color: T.text,
            fontSize: 13,
            resize: "vertical",
            boxSizing: "border-box",
          }}
        />
      </div>
    </>
  );
}
